
export const WebServer = {
  DOMAIN: location.origin,
}

export const StorageKeys = {
  AUTH_CODE: 'auth_code', 
}

// Operation type to apply to entities and lists
export const OPERATION_ADD = 'OPERATION_ADD';
export const OPERATION_REMOVE = 'OPERATION_REMOVE';
export const OPERATION_REPLACE = 'OPERATION_REPLACE';

export const Email = {
  SALES: 'kyle@happystreams.tv',
}

export const FileType = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
}

export const MediaTypes = {
  USER_AVATAR: 'USER_AVATAR',
  PRIZE: 'PRIZE',
}

export const RequestState = {
  REQUEST: 'REQUEST',
  SUCCESS: 'SUCCESS',
  FAIL: 'FAIL',
  NOT_AUTHORIZED: 'NOT_AUTHORIZED',
}

export const Storage = {
  USER_TOKEN: 'hs_user_token',
}

export const ModalTypes = {
  LOGIN: 'login',
  LOGOUT: 'logout',
  SIGNUP: 'signup',
  FORGOT_PASSWORD: 'forgot_password',
  CREATE_USER: 'create_user',
  UPLOAD_MEDIA: 'upload_media',
  FORM: 'FORM',
  HEALTH_CHECK: 'HEALTH_CHECK',
  CHANNEL_PICKER: 'CHANNEL_PICKER',
  CAMPAIGN_PICKER: 'CAMPAIGN_PICKER',
  ADD_CHANNEL: 'ADD_CHANNEL',
  LINK_URLS: 'LINK_URLS',
  CHANNEL_ASSETS: 'CHANNEL_ASSETS',
  BRAND_EDIT: 'BRAND_EDIT',
  CONFIRM: 'CONFIRM',
  EXPORT: 'EXPORT',
  IMAGE: 'IMAGE',
}

export const AppConfig = {
  CHATBOT: 'chatbot',
}

export const Urls = {
  HOME: '/',
  DASHBOARD: '/dashboard',
  DASHBOARD_OLD: '/dashboard/old',

  BRANDS: '/dashboard/brands',
  CAMPAIGNS: '/dashboard/brands',
  CAMPAIGN_NEW_ROUTE: '/dashboard/brand/:brandId/campaign/:campaignId',
  CAMPAIGN_EDIT_ROUTE: '/dashboard/brand/:brandId/campaign/:campaignId',
  CAMPAIGN_DETAILS_ROUTE: '/dashboard/campaign/:campaignId',

  CHANNELS: '/dashboard/channels',
  CHANNEL_DETAILS_ROUTE: '/dashboard/channel/:channelId',
  CHANNEL_SETTINGS_ROUTE: '/dashboard/channel/:channelId/settings',
  MEDIA: '/dashboard/media',

  STREAMS: '/dashboard/streams',
  STREAM_DETAILS_ROUTE: '/dashboard/stream/:streamId',

  LINKS: '/account/links',
  LINK_NEW: '/dashboard/link/edit/new',
  LINK_EDIT_ROUTE: '/dashboard/link/edit/:linkId',

  SLIDES: '/account/slides',

  SLIDESHOW: '/dashboard/slideshow',
  SLIDESHOW_CREATE: '/dashboard/slideshow/create',
  SLIDESHOW_EDIT_ROUTE: '/dashboard/slideshow/:channelId',
  SLIDESHOW_EDIT_OVERLAY_ROUTE: '/dashboard/slideshow/:channelId/:overlayId',
  
  CHAT: '/dashboard/chat/settings',

  ACCOUNT_SETTINGS: '/account/settings',

  OAUTH_SUCCESS: '/oauth/success',
  RESET_PASSWORD: '/auth/reset-password',
}


export const Timespan = {
  MONTH: 'month',
  PREV_MONTH: 'prev_month',
  WEEK: 'week',
  PREV_WEEK: 'prev_week',
  DAYS_30: '30days',
  DAYS_7: '7days',
  HOURS_24: '24hours',
}

export const CampaignStatus = {
  DISABLED: 'disabled',
  ACTIVE: 'active',
  PAUSED: 'paused',
}

export const CampaignTypes = {
  ALL: 'all',
  CHANNELS: 'channels',
  TAGS: 'tags',
}

export const ServiceTypes = {
  TWITCH: 'twitch',
  YOUTUBE: 'youtube',
}

export const KeyCodes = {
  LEFT_ARROW: 37,
  UP_ARROW: 38,
  RIGHT_ARROW: 39,
  DOWN_ARROW: 40,
  ENTER: 13,
  SPACE: 32,
  ESCAPE: 27,
}

export const ReportTypes = {
  ACCOUNT: 'account',
  CHANNELS: 'channels',
  BRANDS: 'brands',
  STREAMS: 'streams',
  SLIDES: 'slides',
  TAGS: 'tags',
  GAMES: 'games',
  CHANNEL: 'channel',
  BRAND: 'brand',
  CAMPAIGN: 'campaign',
  TAG: 'tag',
}

export const Portals = {
  STRIPE: 'stripe-portal',
  TOOLTIP: 'tooltip-portal',
  POPUP: 'popup-portal',
}

export const ConfirmType = {
  DELETE: "delete",
  SAVE: "save",
  DEFAULT: "default",
}